<template>
  <div class="menu-page">
    <!-- 长显：不再使用悬浮控制 -->
    <div class="header_right_balck" style="max-height:100vh">
      <div class="productMenu transition500">
        <div class="left" v-if="isChinese">
          <div
            v-if="item.children"
            class="cursorPointer"
            v-for="(item,index) in productMenuList"
            :key="item.id || index"
            @click="checkTab(index)"
          >
            <p :style="{ width: leftItemWidth ? leftItemWidth + 'px' : 'auto', whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }">
              {{ item.directoryName }}
              <span v-if="index==productIndex" style="margin-left: 6px; flex: 0 0 auto;">>></span>
            </p>
          </div>
        </div>
        <div class="right" v-if="isChinese">
          <div
            class="right_item"
            v-if="productMenuList[productIndex] && productMenuList[productIndex].children"
            v-for="(vItem,vi) in productMenuList[productIndex].children"
            :key="vItem.id || vi"
          >
            <div v-if="vItem.children" class="title cursorPointer">{{ vItem.directoryName }}</div>
            <div
              @click="clickMenuItem(cItem)"
              v-if="vItem.children"
              class="content"
              v-for="(cItem,ci) in vItem.children"
              :key="cItem.id || ci"
            >
              <p class="cursorPointer">{{ cItem.directoryName }}</p>
              <p>{{ cItem.description }}</p>
            </div>
          </div>

          <!-- 隐藏测量容器，用于计算最宽项宽度 -->
          <div ref="measure" class="measure" aria-hidden="true">
            <p class="mitem" v-for="(item,index) in productMenuList" :key="item.id || index">
              {{ item.directoryName }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getJson } from "@/utils/axios";

export default {
  name: "HeaderMenu",
  data() {
    return {
      firstId: 0,
      leftItemWidth: 0,
      productShowList: [
        { label: "首页", value: "0", linkUrl: "https://www.xchr-group.com/index.html" },
        { label: "关于湘楚", value: "1", linkUrl: "https://www.xchr-group.com/about_gyxc.html#qyjj" },
        { label: "产品服务", value: "2", linkUrl: "" },
        { label: "新闻资讯", value: "3", linkUrl: "https://www.xchr-group.com/news.html#qydt" },
        { label: "人才招聘", value: "4", linkUrl: "https://www.xchr-group.com/joinus.html" },
        { label: "党建园区", value: "5", linkUrl: "https://www.xchr-group.com/news.html#xcdj" },
      ],
      productIndex: 0,
      productMenuList: [],
    };
  },
  computed: {
    isChinese() {
      const currentLocale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : "zh-CN";
      return currentLocale === "zh-CN";
    },
  },
  created() {
    this.getMenuList();
  },
  methods: {
    checkHeaderTab(item) {
      const currentLocale = (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : "zh-CN";
      const isChinese = currentLocale === "zh-CN";

      // “首页”：英文/其他外语走站内首页，中文保持原外链
      if (item.value === "0" && !isChinese) {
        const query = { ...(this.$route ? this.$route.query : {}), lang: currentLocale };
        this.$router.push({ name: "IndexHome", query }).catch(() => {});
        return;
      }

      // “关于湘楚”：英文/其他外语走站内 about-xc，中文保持原外链
      if (item.value === "1" && !isChinese) {
        const query = { ...(this.$route ? this.$route.query : {}), lang: currentLocale };
        this.$router.push({ name: "AboutXc", query }).catch(() => {});
        return;
      }

      // 英文下：产品服务/新闻资讯/人才招聘/党建园区不跳转
      if (!isChinese && ["2", "3", "4", "5"].includes(String(item.value))) {
        return;
      }

      // 其余走外链
      if (item.value !== "2") {
        window.open(item.linkUrl);
      }
    },
    clickMenuItem(item) {
      const id = item.id;
      localStorage.setItem('firstId', id);
      // 打开独立详情页路由
      const routeData = this.$router.resolve({ path: '/home/product-detail', query: { id } });
      window.open(routeData.href, '_blank');
    },
    checkTab(index) {
      this.productIndex = index;
    },
    getMenuList() {
      getJson(`/directory/productList`, {}, (res) => {
        if (res.code == 200) {
          this.productMenuList = res.rows || [];
          // const childList = res.rows?.[0]?.children?.[0]?.children || [];
          // this.firstId = childList?.[0]?.id || 0;
          // if (this.firstId) localStorage.setItem("firstId", this.firstId);
          this.$nextTick(() => {
            this.computeLeftMaxWidth();
          });
        } else {
          this.$message && this.$message.error(res.msg);
        }
      });
    },
    computeLeftMaxWidth() {
      try {
        const measure = this.$refs.measure;
        const nodes = measure ? measure.querySelectorAll("p") : [];
        let max = 0;
        nodes.forEach((n) => {
          const w = n.offsetWidth;
          if (w > max) max = w;
        });
        this.leftItemWidth = max;
      } catch (e) {
        // ignore
      }
    },
  },
};
</script>

<style scoped>
.menu-page {
  padding-top: 80px;
}

.header_right_balck {
  display: flex;
  justify-content: space-between;
  color: #333333;
}
.header_right_balck .item {
  z-index: 9999 !important;
  margin-left: 20px;
  padding-left: 10px;
  /* 使用 px，禁止压缩，避免小屏挤压 */
  min-width: 128px;
  flex-shrink: 0;
  white-space: nowrap;
}
.header_right_balck .item:hover {
  color: #1c51a3;
  border-top: 2px solid #1c51a3;
  font-weight: 550;
}

/* 菜单常驻展示，不再 absolute + 悬浮 */
.productMenu {
  z-index: 99;
  position: static;
  width: 100%;
  display: flex;
  background-color: #1c51a3;
  padding: 40px 300px;
  height: 100vh;
}
.productMenu .left {
  display: flex;
  margin-right: 100px;
  flex-direction: column;
}
.productMenu .left p {
  width: auto;
  padding: 0 12px;
  height: 30px;
  margin-bottom: 30px;
  line-height: 30px;
  background-color: #ff9800;
  color: #fff;
}
.productMenu .right {
  height: 540px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-right: 30px;
}
.productMenu .right .right_item {
  border-left: 1px solid #fff;
  padding-left: 20px;
  text-align: left;
  width: 200px;
}
.productMenu .right .right_item .title {
  color: #fff;
  font-weight: 550;
  font-size: 24px;
  height: 40px;
}
.productMenu .right .right_item .content {
  margin-bottom: 26px;
}
.productMenu .right .right_item .content p:nth-child(1) {
  height: 20px;
  font-size: 16px;
  color: #fff;
  min-width: 120px;
}
.productMenu .right .right_item .content p:nth-child(2) {
  height: 20px;
  margin-top: 10px;
  font-size: 12px;
  color: #9eb4d8;
}
.productMenu .right .right_item .content:hover p:nth-child(1) {
  color: #ff9800;
}

/* 隐藏测量容器样式 */
.measure {
  position: absolute;
  visibility: hidden;
  left: -9999px;
  top: -9999px;
  display: block;
}
.measure .mitem {
  padding: 0 12px;
  height: 30px;
  line-height: 30px;
  white-space: nowrap;
}
</style>